import { render, staticRenderFns } from "./quickLinkFrom.vue?vue&type=template&id=7b773dc6&scoped=true"
import script from "./quickLinkFrom.vue?vue&type=script&lang=js"
export * from "./quickLinkFrom.vue?vue&type=script&lang=js"
import style0 from "./quickLinkFrom.vue?vue&type=style&index=0&id=7b773dc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b773dc6",
  null
  
)

export default component.exports